<template>
  <div class="page-create-instance-step-three">
    <nuttrema-loader v-if="SubscriptionReview.fetching || RegionalAndLanguageAll.fetching" theme="full-overlay"></nuttrema-loader>
    <choose-subscription-plan-review
       v-else
      :email="email"
      :SubscriptionReview="SubscriptionReview"
      :RegionalAndLanguageAll="RegionalAndLanguageAll"
      :InstanceRegistrationCheckout="InstanceRegistrationCheckout"
      @checkout="onCheckout"
      @previousStep="onPreviousStep">
    </choose-subscription-plan-review>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import { INSTANCE_REGISTRATION_CODE } from 'constants/values';

import PageProps from 'components/mixins/page-props';

import ChooseSubscriptionPlanReview from 'components/ui/subscription/cmpt-choose-subscription-plan-review';

export default {
  name: 'page-create-instance-step-three',
  mixins: [
    PageProps,
  ],
  components: {
    ChooseSubscriptionPlanReview,
  },
  data() {
    return {
      email: null,
    };
  },
  computed: {
    ...mapGetters([
      'SubscriptionReview',
      'RegionalAndLanguageAll',
      'InstanceRegistrationCheckout',
    ]),
  },
  methods: {
    ...mapActions([
      'GetSubscriptionReview',
      'ProceedInstanceRegistrationCheckout',
    ]),
    onCheckout(payload) {
      this.ProceedInstanceRegistrationCheckout({ payload })
        .then(() => {
          this.decideNextStep();
        })
        .catch(() => {
          this.errorNotification();
        });
    },
    decideNextStep() {
      const code = get(this.InstanceRegistrationCheckout, 'data.code');
      const token = get(this.InstanceRegistrationCheckout, 'data.token');
      const recirectURL = get(this.InstanceRegistrationCheckout, 'data.redirect_url');

      switch (code) {
        case INSTANCE_REGISTRATION_CODE.INSTANCE_REGISTRATION_TRIAL_STARTED:
          // case 1 - trial
          this.onSuccessEvent(null, { trial: true });
          break;
        case INSTANCE_REGISTRATION_CODE.INSTANCE_REGISTRATION_PAYMENT_CHARGE_FAILED:
          // case 2 - show error by code
          break;
        case INSTANCE_REGISTRATION_CODE.INSTANCE_REGISTRATION_PAYMENT_SOURCE_PENDING:
          // case 3 - redirect (3d or similar)
          this.successNotification({ message: 'label.redirect_to_authentication_page' });
          window.location.replace(recirectURL);
          break;
        case INSTANCE_REGISTRATION_CODE.INSTANCE_REGISTRATION_PAYMENT_CHARGE_PENDING:
        case INSTANCE_REGISTRATION_CODE.INSTANCE_REGISTRATION_PAYMENT_CHARGE_SUCCEEDED:
          // case 4 -  recirect to thank you with registration
          this.onSuccessEvent(null, { token });
          break;
        case INSTANCE_REGISTRATION_CODE.INSTANCE_REGISTRATION_BANK_TRANSFER_PENDING:
          // case 1 -
          this.onSuccessEvent(null, { bank: true });
          break;
        default:
          // case 2 - show general error
          break;
      }
    },
    onPreviousStep() {
      this.$router.push({ name: get(this.meta, 'navigation.previous'), query: { email: this.email } });
    },
  },
  created() {
    this.email = get(this.$route, 'query.email', null);
    this.$store.dispatch('GetSubscriptionReview', { query: { email: this.email } });
    this.$store.dispatch('GetRegionalAndLanguageAll', { language_app_support: true, measurement_system_optional: true });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearSubscriptionReview');
    this.$store.dispatch('ClearRegionalAndLanguageAll');
    this.$store.dispatch('ClearInstanceRegistrationCheckout');
  },
};
</script>

<style lang="scss" scoped>
  .page-create-instance-step-three {
    display: flex;
    flex-grow: 1;
  }
</style>




// WEBPACK FOOTER //
// src/components/pages/professional/public/create-instance/step-3/page-create-instance-step-three.vue